<template>
	<a-tag :color="$colors.blue">
		<fa-icon :icon="['far','clock']" />
		{{ $moment(item).format('HH:mm:ss') }}
	</a-tag>
</template>

<script>
export default {
	name: 'GTableSlotTime',
	props: {
		item: {
			type: String,
			required: true
		}
	}
};
</script>

<style lang="scss" scoped>

</style>
